.button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  border-radius: var(--radius-md);
  font-weight: 600;
  letter-spacing: -0.01em;
  white-space: nowrap;
  transition:
    transform var(--duration-fast) var(--ease-out),
    background var(--duration-base) var(--ease-out),
    box-shadow var(--duration-base) var(--ease-out),
    border-color var(--duration-base) var(--ease-out);
}

.button:active:not(:disabled) {
  transform: translateY(1px) scale(0.99);
}

.button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.fullWidth {
  width: 100%;
}

/* --- Sizes ---------------------------------------------------------------- */

.md {
  height: 40px;
  padding: 0 var(--space-4);
  font-size: var(--text-sm);
}

.lg {
  height: 50px;
  padding: 0 var(--space-5);
  font-size: var(--text-base);
  border-radius: var(--radius-lg);
}

.sm {
  height: 32px;
  padding: 0 var(--space-3);
  font-size: var(--text-xs);
  border-radius: var(--radius-sm);
}

/**
 * `sm` and `md` are desktop densities, not sizes.
 *
 * At 32px and 40px both sit under the thumb-target floor, and the console they
 * appear in is now worked from a phone. Grown only where the pointer cannot
 * hover, so a mouse still gets the compact rows they were designed for. The
 * fonts stay put — this is about the target, not the type.
 *
 * Doing it here rather than at each call site is the point: the studio and the
 * wheel editor had both started flooring buttons locally, which is the shape of
 * a fix that gets forgotten on the next screen someone builds.
 */
@media (hover: none) {
  .sm,
  .md {
    height: 44px;
  }

  .sm {
    padding: 0 var(--space-4);
  }
}

/* --- Variants ------------------------------------------------------------- */

.primary {
  color: #fff;
  background: var(--gradient-brand);
  background-size: 160% 160%;
  box-shadow: var(--shadow-brand);
}

.primary::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.22), transparent 60%);
  opacity: 0.8;
  pointer-events: none;
}

.primary:hover:not(:disabled) {
  background-position: 100% 50%;
  box-shadow: 0 14px 36px -10px var(--brand-glow);
}

.secondary {
  color: var(--text-primary);
  background: var(--surface-2);
  border: 1px solid var(--border-subtle);
}

.secondary:hover:not(:disabled) {
  background: var(--surface-3);
  border-color: var(--border-strong);
}

.ghost {
  color: var(--text-secondary);
  background: transparent;
}

.ghost:hover:not(:disabled) {
  color: var(--text-primary);
  background: var(--surface-1);
}

.gold {
  color: #3b2606;
  background: var(--gradient-gold);
  box-shadow: 0 10px 30px -10px rgba(251, 191, 36, 0.5);
}

.gold:hover:not(:disabled) {
  box-shadow: 0 14px 36px -10px rgba(251, 191, 36, 0.65);
}
